// Utility to force logout and clear invalid JWT tokens
function forceLogout(reason = 'Manual logout') {
  console.log(`Force logout triggered: ${reason}`);

  // Clear all authentication data from localStorage
  localStorage.removeItem('user');
  localStorage.removeItem('token');
  localStorage.removeItem('authToken');
  localStorage.removeItem('refreshToken');

  // Clear any other potential auth storage
  sessionStorage.clear();

  // Clear any authentication cookies if they exist
  document.cookie.split(";").forEach(function(c) {
    document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
  });

  // Show a brief notification before reload
  console.log('Authentication cleared. Reloading page...');

  // Small delay to ensure storage is cleared before reload
  setTimeout(() => {
    // Reload the page to ensure clean state
    window.location.reload();
  }, 100);
}

// Enhanced version that can be called from anywhere in the app
function handleAuthError(error) {
  console.error('Authentication error detected:', error);

  // Check if this is a JWT-related error
  const errorMessage = error?.message || error?.toString() || '';
  const isJWTError = errorMessage.includes('JWT') ||
                    errorMessage.includes('signature') ||
                    errorMessage.includes('Forbidden') ||
                    errorMessage.includes('401') ||
                    errorMessage.includes('403');

  if (isJWTError) {
    forceLogout('Invalid JWT token detected');
  }
}

// Make both functions available globally for console use and programmatic access
window.forceLogout = forceLogout;
window.handleAuthError = handleAuthError;

// Listen for storage events to detect when auth is cleared in other tabs
window.addEventListener('storage', (e) => {
  if (e.key === 'user' && e.newValue === null) {
    console.log('User logout detected in another tab, synchronizing...');
    setTimeout(() => window.location.reload(), 100);
  }
});

console.log('Enhanced force logout utility loaded.');
console.log('Available functions:');
console.log('- forceLogout(reason) - Clear auth and reload');
console.log('- handleAuthError(error) - Handle JWT-related errors automatically');
